(()=>{
  if(customElements.get('re-product-video'))return;
  const format=time=>{
    const value=Number.isFinite(time)?Math.max(0,Math.floor(time)):0;
    return Math.floor(value/60)+':'+String(value%60).padStart(2,'0');
  };
  class RoyEliteVideo extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      const video=this.querySelector('video');
      const bar=this.querySelector('.re-video-controls');
      if(!video||!bar)return;
      this.ready=true;
      this.video=video;
      this.bar=bar;
      this.events=new AbortController();
      this.toggleButton=bar.querySelector('[data-action="toggle"]');
      this.soundButton=bar.querySelector('[data-action="sound"]');
      this.fullscreenButton=bar.querySelector('[data-action="fullscreen"]');
      this.seek=bar.querySelector('input');
      this.clock=bar.querySelector('.re-video-time');
      const on=(target,name,listener)=>target.addEventListener(name,listener,{signal:this.events.signal});
      const toggle=()=>{
        if(video.paused||video.ended){
          if(video.ended)video.currentTime=0;
          video.play().catch(()=>{video.controls=true;bar.hidden=true;});
        }else video.pause();
      };
      this.querySelector('.re-video-start')?.remove();
      on(this.toggleButton,'click',toggle);
      on(video,'click',event=>{event.stopPropagation();toggle();});
      on(this.soundButton,'click',()=>{video.muted=!video.muted;this.update();});
      on(this.fullscreenButton,'click',()=>{
        if(this.classList.contains('is-expanded')){this.collapse();return;}
        if(document.fullscreenElement===this){document.exitFullscreen().catch(()=>{});return;}
        const fallback=()=>{
          if(video.webkitEnterFullscreen){try{video.webkitEnterFullscreen();return;}catch(error){}}
          this.previousFocus=document.activeElement;
          this.classList.add('is-expanded');
          if(this.showPopover){this.setAttribute('popover','manual');this.showPopover();}
          this.setAttribute('role','dialog');
          this.setAttribute('aria-modal','true');
          this.setAttribute('aria-label',this.fullscreenButton.getAttribute('aria-label'));
          this.toggleButton.focus();
          this.update();
        };
        try{if(this.requestFullscreen)this.requestFullscreen().catch(fallback);else fallback();}catch(error){fallback();}
      });
      on(this.seek,'input',()=>{
        if(Number.isFinite(video.duration)&&video.duration>0)video.currentTime=Number(this.seek.value)*video.duration/100;
        this.update();
      });
      on(this,'keydown',event=>{
        if(event.target===video&&(event.code==='Space'||event.code==='Enter')){event.preventDefault();toggle();}
      });
      ['click','pointerdown','keydown'].forEach(name=>on(bar,name,event=>event.stopPropagation()));
      ['play','pause','ended','volumechange','loadedmetadata','durationchange','timeupdate','seeked'].forEach(name=>on(video,name,()=>this.update()));
      on(document,'fullscreenchange',()=>this.update());
      on(document,'keydown',event=>{
        if(!this.classList.contains('is-expanded'))return;
        if(event.key==='Escape'){event.preventDefault();this.collapse();}
        if(event.key==='Tab'){
          const controls=Array.from(this.querySelectorAll('video,button,input:not([disabled])'));
          const index=controls.indexOf(document.activeElement);
          if(event.shiftKey&&index<=0){event.preventDefault();controls[controls.length-1].focus();}
          else if(!event.shiftKey&&index===controls.length-1){event.preventDefault();controls[0].focus();}
        }
      });
      on(document,'visibilitychange',()=>{if(document.hidden)video.pause();});
      video.setAttribute('tabindex','0');
      video.controls=false;
      bar.hidden=false;
      this.update();
      this.intersection=new IntersectionObserver(entries=>{if(!entries[0].isIntersecting)video.pause();},{threshold:.1});
      this.intersection.observe(this);
      const slide=this.closest('.yv-product-slider-item');
      if(slide){
        this.selection=new MutationObserver(()=>{
          if(slide.closest('.flickity-enabled')&&!slide.classList.contains('is-selected'))video.pause();
        });
        this.selection.observe(slide,{attributes:true,attributeFilter:['class','aria-hidden']});
      }
      this.section=this.closest('.shopify-section');
      if(this.section)on(this.section,'change',event=>{if(!this.contains(event.target))video.pause();});
    }
    update(){
      const video=this.video;
      if(!video)return;
      this.classList.toggle('is-playing',!video.paused&&!video.ended);
      this.classList.toggle('is-muted',video.muted);
      this.toggleButton.setAttribute('aria-label',video.paused||video.ended?this.dataset.play:this.dataset.pause);
      this.soundButton.setAttribute('aria-label',video.muted?this.dataset.unmute:this.dataset.mute);
      this.soundButton.setAttribute('aria-pressed',String(!video.muted));
      this.fullscreenButton.setAttribute('aria-pressed',String(document.fullscreenElement===this||this.classList.contains('is-expanded')));
      const duration=Number.isFinite(video.duration)&&video.duration>0?video.duration:0;
      this.seek.disabled=!duration;
      this.seek.value=duration?video.currentTime/duration*100:0;
      this.clock.textContent=format(video.currentTime)+' / '+format(duration);
      this.seek.setAttribute('aria-valuetext',this.clock.textContent);
    }
    collapse(){
      if(this.hasAttribute('popover')){this.hidePopover();this.removeAttribute('popover');}
      this.classList.remove('is-expanded');
      this.removeAttribute('role');
      this.removeAttribute('aria-modal');
      this.removeAttribute('aria-label');
      this.update();
      if(this.previousFocus?.isConnected)this.previousFocus.focus();
    }
    disconnectedCallback(){
      this.events?.abort();
      this.intersection?.disconnect();
      this.selection?.disconnect();
      this.video?.pause();
      this.classList.remove('is-expanded');
      this.ready=false;
    }
  }
  customElements.define('re-product-video',RoyEliteVideo);
})();
(()=>{if(document.documentElement.lang.split('-')[0]!=='es')return;
const words={'Customer Reviews':'Reseñas de clientes','Sort by':'Ordenar por','Most Recent':'Más recientes','Highest Rating':'Mayor puntuación','Lowest Rating':'Menor puntuación','Only Pictures':'Solo con fotos','Pictures First':'Fotos primero','Videos First':'Vídeos primero','Most Helpful':'Más útiles','Write a review':'Escribir una reseña'};
function localize(){if(!document.querySelector('.re-dw-panels'))return;document.querySelectorAll('.jdgm-prev-badge__text,.jdgm-rev-widg__title,.jdgm-rev-widg__summary-text,.jdgm-sort-dropdown option,.jdgm-sort-dropdown-wrapper label,.jdgm-sort-dropdown-wrapper>span').forEach(e=>{const old=e.textContent;const next=words[old.trim()]||old.replace(/Based on (\d+) reviews/,'Basado en $1 reseñas').replace(/(\d+(?:\.\d+)?) out of 5/,'$1 de 5').replace(/\breviews\b/gi,'reseñas').replace(/\breview\b/gi,'reseña');if(next!==old)e.textContent=next});document.querySelectorAll('.jdgm-paginate__page[aria-label]').forEach(e=>{const old=e.getAttribute('aria-label');const next=old.replace(/^Page (\d+)$/,'Página $1');if(next!==old)e.setAttribute('aria-label',next)})}
function start(){if(!document.querySelector('.re-dw-panels'))return;localize();new MutationObserver(localize).observe(document.querySelector('main'),{childList:true,subtree:true})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start()})();

/* Native horizontal galleries also expose explicit, keyboard-accessible navigation. */
(()=>{
  function bindGalleryNavigation(){
    document.querySelectorAll('.main-slider-wrapper').forEach(wrapper=>{
      const slider=wrapper.querySelector('.data-main-slider');
      const prev=wrapper.querySelector('[data-re-gallery-prev]');
      const next=wrapper.querySelector('[data-re-gallery-next]');
      if(!slider||!prev||!next||slider.dataset.reNavigationBound)return;
      slider.dataset.reNavigationBound='true';
      const items=()=>Array.from(slider.querySelectorAll('.yv-product-slider-item')).filter(item=>item.getBoundingClientRect().width>0);
      const index=list=>slider.classList.contains('flickity-enabled')?Math.max(0,list.findIndex(item=>item.classList.contains('is-selected'))):list.reduce((best,item,i)=>Math.abs(item.offsetLeft-list[0].offsetLeft-slider.scrollLeft)<Math.abs(list[best].offsetLeft-list[0].offsetLeft-slider.scrollLeft)?i:best,0);
      const update=()=>{const list=items();if(!list.length)return;const selected=index(list);prev.disabled=selected===0;next.disabled=selected===list.length-1;const count=wrapper.querySelector('[data-re-gallery-count]');if(count)count.textContent=(selected+1)+' / '+list.length;};
      const move=direction=>{const list=items();if(!list.length)return;if(slider.classList.contains('flickity-enabled')){slider.querySelector(direction<0?'.flickity-prev-next-button:not(.next)':'.flickity-prev-next-button.next')?.click();return;}const selected=Math.max(0,Math.min(list.length-1,index(list)+direction));slider.scrollTo({left:list[selected].offsetLeft-list[0].offsetLeft,behavior:'instant'});};
      prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
      slider.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update);new MutationObserver(update).observe(slider,{subtree:true,attributes:true,attributeFilter:['class','aria-hidden']});update();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bindGalleryNavigation,{once:true});else bindGalleryNavigation();
  document.addEventListener('shopify:section:load',bindGalleryNavigation);
})();


(()=>{function update(scope){scope.querySelectorAll('.re-option-heading').forEach(heading=>{const group=heading.closest('.product-option-selector'),value=group?.querySelector('input.productOption:checked,select.productOption'),output=heading.querySelector('[data-re-selected-option]');if(value&&output)output.textContent=value.value})}function start(){update(document);document.addEventListener('change',event=>{const group=event.target.closest?.('.product-option-selector');if(group)update(group)})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start()})();
